import { Link } from "react-router-dom";

export function Brand() {
  return (
    <Link
      to="/"
      aria-label="A2bait home"
      className="brand-lockup-link"
    >
      <span className="brand-lockup-image" aria-hidden="true" />
      <span className="sr-only">A2bait — Catch Issues Before Carriers Do</span>
    </Link>
  );
}
